export const SET_AUTH = 'SET_AUTH';
export const LOG_OUT = 'LOG_OUT';
export const SET_USER = 'SET_USER';
export const SET_WALLET = 'SET_WALLET';
export const SET_SHOW_BALANCE = 'SET_SHOW_BALANCE';
export const SET_DRAWER_ACCOUNT = 'SET_DRAWER_ACCOUNT';
export const SET_DRAWER_NOTIFICATIONS = 'SET_DRAWER_NOTIFICATIONS';
export const SET_UNREAD_COUNT = 'SET_UNREAD_COUNT';
export const SET_NEW_TRANSACTIONS = 'SET_NEW_TRANSACTIONS';
